import states from '../constants/states.json'

export const formatStateName = (value = '') => {
    const myState = states.find(state => state.value === value)

    return myState?.name || ''
}